import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// import ApplicationForm from './ApplicationForm'; 
// import NewsletterSignup from "./NewsletterSignup";
import { logout } from '../../redux/actions/authActions';

const YUVASolverHome = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName, setUserName] = useState(authState.user.name);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <div className="font-sans text-white bg-black">
      <header className="flex justify-between items-center mt-2 px-4 bg-black shadow-md sticky top-0 z-50  border-b border-blue-400">
        <div className="flex flex-col">
          <p className="text-xl lg:text-2xl font-bold text-yellow-200 tracking-wide">YUVASolver</p>
          <p className="text-sm lg:text-sm text-white">National Mission for School Problem Solving</p>
          <p className="text-sm lg:text-sm text-yellow-200">Empowering India’s youth with the mindset to question, analyze and solve - scientifically.</p>
        </div>
        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn ? (
            <>
              <span className="text-yellow-200 text-xs lg-text-sm">{userName}</span>
              <button
                onClick={handleLogout}
                className="mt-2 w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm border border-blue-500 text-blue-600 rounded-full hover:bg-blue-50 transition"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <div className="md:hidden flex items-center justify-end w-24">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-xl w-8 text-black bg-blue-400 focus:outline-none"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black px-4 py-4 space-y-1 text-center shadow-md sm:px-6">
          {isLoggedIn && (
            <div className="flex flex-col items-center text-gray-800">
              <p className="text-blue-600 text-xs lg:text-sm">{userName}</p>
              <div className="flex space-x-4 mt-2">
                <button
                  onClick={handleLogout}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                >
                  ⏻
                </button>
              </div>
            </div>
          )}
          {!isLoggedIn && (
            <div className="flex justify-center space-x-4 pt-2">
              <button 
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm border border-blue-500 text-blue-600 rounded-full hover:bg-blue-50 transition"
              >
                Login
              </button>
            </div>
          )}
        </div>
      )}

      <section
        className="relative h-[75vh] bg-cover bg-center flex items-center justify-center text-white px-4 py-4"
        style={{
          backgroundImage: "url('/assets/banners/yuvasolver.webp')",
        }}
      >
        <div className="relative z-10 text-center w-full max-w-4xl">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 ">
            <button
              onClick={() => navigate("/rcas/add")}
              className="px-4 py-3 text-base sm:text-lg font-semibold bg-blue-600 rounded-lg hover:bg-blue-700 transition hover:text-yellow-200 flex items-center justify-center space-x-2"
            >
              <span>🧠</span>
              <span className="text-xs lg:text-sm">DeepThink Lab</span>
            </button>
            <button
              onClick={() => navigate("/tasks/add")}
              className="px-4 py-3 text-base sm:text-lg font-semibold bg-blue-600 rounded-lg hover:bg-blue-700 transition hover:text-yellow-200 flex items-center justify-center space-x-2"
            >
              <span>📖</span>
              <span className="text-xs lg:text-sm">Chronicle</span>
            </button>
            <button
              onClick={() => navigate("/aicounselling")}
              className="px-4 py-3 text-base sm:text-lg font-semibold bg-blue-600 rounded-lg hover:bg-blue-700 transition hover:text-yellow-200 flex items-center justify-center space-x-2"
            >
              <span>🤖</span>
              <span className="text-xs lg:text-sm">AI Counselling</span>
            </button>
            <button
              onClick={() => navigate("/topofthelot")}
              className="px-4 py-3 text-base sm:text-lg font-semibold bg-blue-600 rounded-lg hover:bg-blue-700 transition hover:text-yellow-200 flex items-center justify-center space-x-2"
            >
              <span>🔥</span>
              <span className="text-xs lg:text-sm">TopOfTheLot</span>
            </button>
          </div>
        </div>
      </section>

      <footer className="bg-black border-t border-blue-400 text-white py-2 px-4 flex flex-col lg:flex-row justify-between items-center">
          <div><p className="text-sm text-yellow-200">&copy; 2025 Think5Whys Global DeepTech Solutions.</p></div>
          <div className="flex space-x-6 mt-2 text-sm [_&p]:text-white">
            <Link to="/about-us" className="text-white hover:text-blue-400 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-400 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-400 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-400 transition">Contact</Link>
          </div>
      </footer>
    </div>
  );
};

export default YUVASolverHome;